﻿// tippy
import tippy, { followCursor } from 'tippy.js';
import 'tippy.js/dist/tippy.css';

// scale animation
import 'tippy.js/animations/scale.css';

// theme
//import 'tippy.js/themes/light.css';

function loadTippyContent(reference) {
    let id = reference.getAttribute('tooltip');
    if (id) {
        let template = document.getElementById(id);
        if (template) {
            return template.innerHTML;
        } else {
            return 'NOT_FOUND_DATA_TEMPLATE';
        }
    } else {
        return 'NO_DATA_TEMPLATE';
    }
}

//window.tippyInstances = [];
function loadTippyTooltips() {
    // clear tippies
    //tippyInstances.forEach(instance => {
    //    instance.destroy();
    //});
    //tippyInstances.length = 0;
    // clear tippies
    [...document.querySelectorAll('*')].forEach(node => {
        if (node._tippy) {
            node._tippy.destroy();
        }
    });

    // load tippies
    tippy('[tooltip]', {
        content(reference) {
            return loadTippyContent(reference);
        },
        allowHTML: true,
        //animation: 'scale',
        theme: 'zis-tooltip-theme',
        arrow: true,
        zIndex: 999999,
    });
    // store tippies
    //window.tippyInstances = tippyInstances.concat(instances);
}

document.addEventListener('htmx:afterSettle', function () {
    loadTippyTooltips();
});

document.addEventListener('DOMContentLoaded', function () {
    loadTippyTooltips();
});

tippy.setDefaultProps({ delay: [800, 50] });